export const webview = (window as any).flutter_inappwebview

/**
 * Verifies if the current environment is a Flutter WebView.
 * @returns {boolean} True if running inside a Flutter WebView, false otherwise.
 */
export function verifyWebViewRender(): boolean {
  return !!webview
}
